import { render, staticRenderFns } from "./makeup.vue?vue&type=template&id=c70fd164&scoped=true&"
import script from "./makeup.vue?vue&type=script&lang=js&"
export * from "./makeup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70fd164",
  null
  
)

export default component.exports